import { useMemo } from 'react';

import { useAuth0 } from '@auth0/auth0-react';

import { getUserDisplayName } from '../utils/userName';

/**
 * Hook to get the user's display name from Auth0
 * @return {string} The user's display name
 */
export const useUserName = (): string => {
  const { user } = useAuth0();

  return useMemo(() => getUserDisplayName(user), [user]);
};
